<template>
  <div class='AddBlacklist'>
    <adm-title text="Subdomínio não permitido"/>
    <div class="cont-input">
      <adm-input @returnValue="newValue => text = newValue" label="subdomínio" width="350px"/>
    </div>
    <bot-actions>
      <adm-btn text="salvar" @click="push"/>
    </bot-actions>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AdmTitle from '../AdmTitle'
import AdmInput from '../AdmInput'
import BotActions from '../botActions/BotActions'
import AdmBtn from '../topActions/AdmBtn'
export default {
  name: 'AddBlacklist',
  components: { AdmTitle, AdmInput, BotActions, AdmBtn },
  data () {
    return {
      text: ''
    }
  },
  methods: {
    ...mapActions(['_CreateBlacklist']),
    push () {
      if(this.text === '') {
        return
      }
      this._CreateBlacklist(this.text)
        .then(() => {
          this.$router.push('/enb/workspace/blacklist')
        })
    }
  }
}
</script>

<style scoped>
.AddBlacklist {
  width: 100%;
  height: 94%;
}
.cont-input {
  padding-left: 2%;
}
</style>
